import Dashboard from '../../components/dash';

export default Dashboard;